/* eslint-disable no-mixed-spaces-and-tabs */
import React from 'react';
import InsightSelect from '@/components/selects/InsightSelect';
import { useFormikContext } from 'formik';
import FieldFormControl from '../FieldFormControl';

export const InsightSelectFormikWrapper = ({
	field,
	disabled,
	labelStyle,
	isOptionDisabled = (option) => false,
	autofillIfNull = false,
}) => {
	const { values, setFieldValue, getFieldMeta, getFieldHelpers, getFieldProps, ...formik } =
		useFormikContext();
	const { onBlur: onFieldBlur } = getFieldProps(field.name);
	const { setTouched } = getFieldHelpers(field.name);

	const onBlur = (e) => {
		onFieldBlur(e);
		setTouched(true, true);
	};

	const { field: fieldConfig } = field;

	const { error: errorMessage, touched } = getFieldMeta(field.name);
	const error = touched && Boolean(errorMessage);

	return (
		<FieldFormControl {...{ field, disabled, label: field.label, labelStyle }}>
			<InsightSelect
				endpoint={fieldConfig.endpoint}
				value={values[field.name]}
				clearable={true}
				isOptionDisabled={isOptionDisabled}
				autofillIfNull={autofillIfNull}
				onChange={(value) => {
					setFieldValue(
						field.name,
						value
							? {
									Name: value.Name,
									Id: value.Id,
									...(value.Code && { Code: value.Code }),
								}
							: null,
					);

					console.log('Selected Insight value', value);
				}}
				{...(fieldConfig.fieldType === 'radio' && { variant: 'radio' })}
				{...{ onBlur, error, disabled }}
			/>
		</FieldFormControl>
	);
};
